module.exports = __webpack_public_path__ + "static/media/proceso-video.afce7269.jpg";